// extracted by mini-css-extract-plugin
export default {"tray":"App_tray__gywk5","expanded":"App_expanded__NKPkg","toggle":"App_toggle__JhTcu"};